import { memo, useEffect } from "react";

import { usePrefetchPdf } from "@/components/shared/pdf-tools/hooks/use-prefetch-pdf";
import { useInvoiceBrowser } from "@/providers/invoice-browser";
import { useInvoicePdfCache } from "@/providers/invoice-pdf-cache";

const _PreFetchPDF = ({
  setErrorMessage,
  invoiceId,
  setPdfBlob,
}: {
  setErrorMessage: (message: string) => void;
  invoiceId: string;
  setPdfBlob: (blob: string | null) => void;
}) => {
  const { fetchPdf } = useInvoicePdfCache();

  const {
    currentIndex: currentQueueIndex,
    canGoNext,
    canGoBack,
    getElementOnQueue,
  } = useInvoiceBrowser();

  const { blob } = usePrefetchPdf({
    canGoNext,
    canGoBack,
    currentQueueIndex,
    fetchPdf,
    invoiceId,
    getElementOnQueue,
    setErrorMessage,
  });

  useEffect(() => {
    setPdfBlob(blob ?? null);
  }, [blob, setPdfBlob]);

  return null;
};

export const PreFetchPDF = memo(_PreFetchPDF);
